export const getMunicipalityBorder = (komid) => new Promise((res, rej) => {
  // console.log(komid, 'to server');
  const api = '/municipality_ws/kommunegrense';
  const request = new Request(`${api}?komid=${komid}&decimals=0`, {
    method: 'GET',
    headers: new Headers({ 'Content-Type': 'application/json' })
  });
  fetch(request).then(r => r.json()).then(json => res(json)).catch(e => rej(e));
});
